"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthShortNames = void 0;
exports.MonthShortNames = {
    "fr-ca": [
        "jan",
        "fév",
        "mars",
        "avr",
        "mai",
        "juin",
        "juil",
        "août",
        "sept",
        "oct",
        "nov",
        "déc",
    ],
    "fr-ch": [
        "jan",
        "fév",
        "mars",
        "avr",
        "mai",
        "juin",
        "juil",
        "août",
        "sept",
        "oct",
        "nov",
        "déc",
    ],
    "fr-fr": [
        "jan",
        "fév",
        "mars",
        "avr",
        "mai",
        "juin",
        "juil",
        "août",
        "sept",
        "oct",
        "nov",
        "déc",
    ],
};
